import { ChangeDetectionStrategy, Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

/**
 * Thin layout layer between the shared lib-app-layout shell and the feature
 * routes. Adds the standard content padding (matching the portal app) around
 * the routed content without touching the shared shell or each feature's card,
 * so rounded card borders stay intact.
 */
@Component({
  selector: 'boffice-content-layout',
  imports: [RouterOutlet],
  template: '<div class="h-full overflow-hidden p-1 sm:p-2 lg:p-4"><router-outlet /></div>',
  host: { class: 'block h-full' },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentLayoutComponent {}
